import { render, staticRenderFns } from "./StaffFilter.vue?vue&type=template&id=2858cf64"
import script from "./StaffFilter.vue?vue&type=script&lang=js"
export * from "./StaffFilter.vue?vue&type=script&lang=js"
import style0 from "./StaffFilter.vue?vue&type=style&index=0&id=2858cf64&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2858cf64')) {
      api.createRecord('2858cf64', component.options)
    } else {
      api.reload('2858cf64', component.options)
    }
    module.hot.accept("./StaffFilter.vue?vue&type=template&id=2858cf64", function () {
      api.rerender('2858cf64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Calendar/StaffFilter.vue"
export default component.exports